import React from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML, titleize } from 'underscore.string';
import CargomaticCard from 'components/v2/card';
import Badge from '../../../v2/Badge';
import 'utils/selectize';
import { Avatar } from '../Avatar';

const ConsigneeProfileCard = ({ consignee }) => {
  const { authorized, _id } = consignee;
  const { t } = useTranslation();
  return (
    <CargomaticCard className="mb-6">
      <div className="text-center">
        <div className="flex justify-center py-6">
          <Avatar
            key={_id}
            userId={_id}
            className="h-32 w-32 cursor-pointer rounded-full"
          />
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-2 ">
          <Badge color="pink">{t('CONSIGNEE')}</Badge>
          {authorized ? (
            <Badge color="green">{titleize(t('AUTHORIZED'))}</Badge>
          ) : (
            <Badge color="red">{t('UNAUTHORIZED')}</Badge>
          )}
        </div>
        <h3 className="my-2 text-xl text-grey-darker">
          {unescapeHTML(consignee?.company_name)}
        </h3>
      </div>
    </CargomaticCard>
  );
};

export default ConsigneeProfileCard;
